import styles from "@/components/modal/license-limited-modals/styles/license-limited-modal.module.scss";
import React from "react";
import ViewPlansButton from "@/components/common/view-plans-button";
import { useGlobalModalContext } from "@/providers/modal-provider/modal-provider";
import { TRIAL_CONVERT_RESULT_LIMIT_SECS } from "@/services/license/license-managers/convert-voice-license-manager";
import GetFreeAccessButton from "@/components/common/get-free-access-button";
import Link from "next/link";
import UnfilledButton from "@/components/common/unfilled-button";

type ResultLimitedModalProps = {
  onPreviewSongClick?: () => void;
};

const ResultLimitedModal = ({
  onPreviewSongClick,
}: ResultLimitedModalProps) => {
  const { hideModal } = useGlobalModalContext();

  return (
    <div className={styles.trial_modal}>
      <div className={styles.main_text}>
        Thank you for using <br /> Trial version of AudioModify!
      </div>
      <div className={styles.secondary_text}>
        You&apos;re currently limited to a {TRIAL_CONVERT_RESULT_LIMIT_SECS}
        -second AI cover demo.
      </div>
      <div className={styles.secondary_text}>
        Please upgrade to the paid version to generate unlimited AI cover songs
        without duration limits, and get access to dozens of other AI tools for
        music, like AI Mastering.
      </div>
      <Link href={"/pricing"} target={"_blank"} onClick={hideModal}>
        <UnfilledButton text={"Unlock Full Access"} borderColor={"#F9A825"} />
      </Link>

      <div className={styles.buttons_container}>
        <UnfilledButton
          text={"Preview Song"}
          borderColor={"#F9A825"}
          onClick={onPreviewSongClick ?? hideModal}
        />
        <GetFreeAccessButton />
      </div>
    </div>
  );
};

export default ResultLimitedModal;
